import React from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';

import * as CONSTANTS from '../constants';

const THEME = require('../theme')[CONSTANTS.partner];

const theme = createTheme(THEME.login);

const MaintenancePage = () => (
  <div className="container-fluid h-100vh" style={THEME.loginBackground}>
    <div className="row justify-content-center align-items-center h-100">
      <div className="col col-sm-8 col-md-6 col-lg-4 col-xl-3">
        <MuiThemeProvider theme={theme}>
          <Paper style={{ ...THEME.loginPaper, padding: '2em', textAlign: 'center' }} elevation={24}>
            <img
              src={THEME.loginLogo}
              alt="Logo"
              style={{ ...THEME.loginLogoStyle, marginBottom: '24px', display: 'block', margin: '0 auto 24px' }}
            />
            <Typography variant="body1" style={{ color: '#fff', lineHeight: 1.7 }}>
              Aufgrund von Wartungsarbeiten ist diese Applikation am 22.06.2026 von 17:00 bis 21:00 nicht erreichbar.
            </Typography>
          </Paper>
        </MuiThemeProvider>
      </div>
    </div>
  </div>
);

export default MaintenancePage;
